var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardWrap clearfix" },
    [
      _c("div", { staticClass: "cardText clearfix card-background" }, [
        _c("div", { staticClass: "cardText clearfix cardLine" }, [
          _c("div", { staticStyle: { float: "left" } }, [_vm._t("default")], 2),
          _c("div", { staticClass: "logoAndStar clearfix" }),
          _c("div", { staticClass: "details" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                {
                  staticClass: "clearfix img-box",
                  class:
                    _vm.baseData.source === "douyin"
                      ? "img-box-dy"
                      : "img-box-ks",
                  staticStyle: {},
                },
                [_c("i", { staticClass: "iconfont icon-duanshipin" })]
              ),
              _c("div", [
                _c("div", { staticClass: "nameWrap mb-10" }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.baseData.nickName)),
                  ]),
                ]),
                _vm.baseData.source || _vm.baseData.constellation
                  ? _c("div", { staticClass: "nameWrap mb-10" }, [
                      _vm.baseData.source
                        ? _c(
                            "span",
                            {
                              staticClass: "tag platform",
                              class:
                                _vm.baseData.source === "douyin"
                                  ? "platform-dy"
                                  : "platform-ks",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.baseData.source === "douyin" ? "DY" : "KS"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.baseData.constellation !== "0" &&
                      _vm.baseData.constellation !== null
                        ? _c("span", { staticClass: "tag constellation" }, [
                            _vm._v(
                              _vm._s(
                                _vm.constellation(_vm.baseData.constellation)
                              )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("dl", { staticClass: "text" }, [
                  _c("dd", { staticClass: "mr-10" }, [
                    _c("div", { staticClass: "textOverflow" }, [
                      _c("span", [_vm._v("评论时间：")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$moment(_vm.baseData.createTime * 1000)
                              .format("YYYY-MM-DD")
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "textOverflow" }, [
                      _c("span", [_vm._v("关键词内容：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.baseData.keyWord || "--")),
                      ]),
                    ]),
                  ]),
                  _c("dd", { staticClass: "mr-10" }, [
                    _c("div", { staticClass: "textOverflow" }, [
                      _c("span", [_vm._v("评论点赞数：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.baseData.awemeCount || 0)),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "address textOverflow" },
                  [
                    _c("span", [_vm._v("视频源地址：")]),
                    _vm.baseData.comDesc && _vm.baseData.comDesc.length > 35
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.baseData.comDesc,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.baseData.videoUrl,
                                  referrerpolicy: "no-referrer",
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(_vm.baseData.comDesc))]
                            ),
                          ]
                        )
                      : _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.baseData.videoUrl || "",
                              referrerpolicy: "no-referrer",
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.baseData.comDesc || "--"))]
                        ),
                  ],
                  1
                ),
                _c("div", { staticClass: "inquiry-content" }, [
                  _c("div", { staticClass: "tRecommend" }, [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "text2 textOverflow",
                        staticStyle: { "margin-left": "10px", width: "100%" },
                      },
                      [
                        _vm.baseData.text && _vm.baseData.text.length > 25
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                staticStyle: {
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                                attrs: {
                                  effect: "dark",
                                  content: _vm.baseData.text,
                                  placement: "top",
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.baseData.text))])]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(_vm.baseData.text || "--")),
                            ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "btns" },
            [
              _vm.baseData.isUnlock === "0"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "interestExpire", rawName: "v-interestExpire" },
                      ],
                      staticClass: "small-drawer-btn",
                      staticStyle: {
                        "margin-top": "70px",
                        background: "#4F7AFD",
                      },
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.immediatelyUnlock(_vm.baseData)
                        },
                      },
                    },
                    [_vm._v("立即解锁")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "small-drawer-btn",
                      staticStyle: {
                        "margin-top": "70px",
                        background: "#e9ab59",
                      },
                      attrs: { type: "warning", size: "mini" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.checkDetails(_vm.baseData)
                        },
                      },
                    },
                    [_vm._v("查看详情")]
                  ),
            ],
            1
          ),
        ]),
      ]),
      _c("companyListDrawer", {
        ref: "vNumber",
        attrs: { companyStatus: _vm.inquiryData, waiting: _vm.waiting },
        on: { refreshList: _vm.contactList, lookNumber: _vm.lookNumberInner },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("span", [_vm._v("询盘内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }